export enum CreateAccountState {
    Loading,
    RegisterEmail,
    VerifyEmail,
    AddAccountDetails,
    SetPassword,
    Success,
}